var map = {
	"./CalendarCadenceGetStarted.svg": 4684,
	"./CalendarCadenceHome.svg": 20802,
	"./ComprehensiveView.svg": 22651,
	"./CustomerView2.svg": 35943,
	"./DegreedPathway.svg": 14850,
	"./LandingFirstImg.svg": 20958,
	"./LandingForthImg.svg": 14127,
	"./LandingSecondImg.svg": 63410,
	"./PortfolioMasterDataIllustration.svg": 84024,
	"./PortfolioMasterDataMissingIcon.svg": 53561,
	"./RegionSelectionIcon.svg": 14033,
	"./Symbol.svg": 67392,
	"./TPOLogo.svg": 93662,
	"./Trend.svg": 28641,
	"./addsubtask.svg": 94126,
	"./alignmentandaction.svg": 15408,
	"./analytics.svg": 43964,
	"./attachmentImage.svg": 9698,
	"./bannerimage.svg": 38157,
	"./bookmark.svg": 51836,
	"./business.svg": 962,
	"./calendarBannerHomepage.svg": 45692,
	"./calendarInfiIcon.svg": 67819,
	"./cycle_trigger_image.svg": 95645,
	"./cycleanalytics.svg": 21518,
	"./decisionMakingCentral.svg": 77576,
	"./downloadIcon.svg": 54167,
	"./editpenicon.svg": 59502,
	"./excelIcon.svg": 43434,
	"./help_icon.svg": 67795,
	"./homeicon.svg": 64606,
	"./map.svg": 41081,
	"./materialAvatar.svg": 6316,
	"./navbarButton.svg": 67530,
	"./new_tab.svg": 80234,
	"./portfolio-health-icon.svg": 20035,
	"./portfolioLinkIcon.svg": 5223,
	"./profile_carousel_image_1.svg": 67330,
	"./profile_carousel_image_2.svg": 38225,
	"./profile_carousel_image_3.svg": 75424,
	"./profile_welcome_image.svg": 24200,
	"./profit.svg": 35746,
	"./profitAvatar.svg": 11429,
	"./readiness.svg": 93860,
	"./refresh.svg": 61117,
	"./revenue.svg": 89660,
	"./revenueAvatar.svg": 27775,
	"./salesAvatar.svg": 9079,
	"./setup_team.svg": 89225,
	"./teamsIcon.svg": 35933,
	"./test.svg": 96672,
	"./votingstepper.svg": 95584,
	"./warning.svg": 92088,
	"./wasteAvatar.svg": 79629
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92810;